import { isObjectEmpty } from '@/helpers/dataHelpers';

const DEFAULT_STANDUP_MEETING_DAY_IDS = [2, 3, 4, 5, 6];
const DEFAULT_REPORTING_DAY_IDS = [1, 2];
const DEFAULT_TIME_ZONE_ID = 1;
const DEFAULT_STANDUP_TIME_ID = 37;

export const DEFAULT_TEAM = {
  timeZoneId: DEFAULT_TIME_ZONE_ID,
  standupMeetingTimeId: DEFAULT_STANDUP_TIME_ID,
  standupMeetingDayIds: DEFAULT_STANDUP_MEETING_DAY_IDS,
  standupReportingDayIds: DEFAULT_REPORTING_DAY_IDS,
  userIds: [],
  isPrivate: false,
};

export function getUserTeams(userId, teams) {
  if (isObjectEmpty(teams) || !userId) return [];

  return Object.values(teams)
    .filter(team => team.userIds.includes(userId));
}
